import app from 'flarum/forum/app';

import Search, { SearchAttrs, SearchSource } from 'flarum/forum/components/Search';

import { extend } from 'flarum/common/extend';
import ItemList from 'flarum/common/utils/ItemList';

import DiscussionsSearchSource from './SearchSources/DiscussionsSearchSource';
import extendDiscussionState from './PaginatedListStates/extendDiscussionState';

app.initializers.add('blomstra-search', () => {
  const minLength = parseInt(app.data.settings['blomstra-search.min-search-length'] || String(Search.MIN_SEARCH_LEN), 10);
  if (minLength !== Search.MIN_SEARCH_LEN) {
    (Search as any).MIN_SEARCH_LEN = minLength;
  }

  extend(Search.prototype, 'sourceItems', function (this: Search<SearchAttrs>, items: ItemList<SearchSource>) {
    items.replace('discussions', new DiscussionsSearchSource());
  });
});

app.initializers.add(
  'blomstra-search-early',
  () => {
    extendDiscussionState();
  },
  999999
);
